import { useQuery } from '@tanstack/react-query';
import { promotionsQueryKey } from 'queries/promotions/queryKey';
import { PromotionApi } from 'api/ApiHelper';

export const useGetPromotionItemQuery = (id: number, isActive?: boolean) =>
  useQuery({
    queryKey: promotionsQueryKey.promotionItems(id, isActive),
    queryFn: () => PromotionApi.getPromotionItems(id, isActive),
    gcTime: 0,
  });
